import { Grid, makeStyles, Paper } from "@material-ui/core";
import { Field, FieldProvider, Text, TextArea, Numeric, DatePicker, FuzzySelect } from "@ngt/forms";
import { useFormActions, useScopedField } from "@ngt/forms-core";
import { FunctionComponent, useEffect } from "react";
import * as Dtos from '../../api/dtos';
import Attachment from "../../components/Attachment";
import FormContainer from "../../components/layouts/FormContainer";
import { fieldMargin, gridFieldMargin } from "../../constants/forms";
import { DOLLAR_PREFIX, PERCENT_SUFFIX } from "../../constants/inputAdornments";
import { INTEGER_FORMAT, MONEY_FORMAT, PERCENTAGE_FORMAT } from "../../constants/numberFormats";
interface IBankGuarenteeRequestProps {}
const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2, 2, 2, 2),
    margin: theme.spacing(2, 0, 2, 0)
  }
}));
const subscription = {};
const TotalAmountUpdater: FunctionComponent = () => {
  const {
    subscribe
  } = useFormActions<Dtos.BankGuaranteeRequest, Dtos.IValidationError>();
  const {
    context: {
      setValue: setTotalAmount
    }
  } = useScopedField<Dtos.BankGuaranteeRequest['totalAmountOfBankGuarantees'], Dtos.IValidationError>('totalAmountOfBankGuarantees', subscription);
  useEffect(() => {
    const unsubscribe = subscribe(formState => {
      const {
        numberOfGuarantees,
        amountOfEachGuarantee
      } = formState.values;
      const totalAmount = (numberOfGuarantees ?? 0) * (amountOfEachGuarantee ?? 0);
      setTotalAmount(totalAmount, false, true, true);
    }, {
      values: true,
      dirty: false,
      errors: false,
      fields: false,
      focused: false,
      initialValues: false,
      submitting: false,
      touched: false,
      validating: false
    });
    return () => {
      unsubscribe();
    };
  }, [setTotalAmount, subscribe]);
  return null;
};
const BankGuaranteeRequest: FunctionComponent<IBankGuarenteeRequestProps> = () => {
  const classes = useStyles();
  return <FormContainer maxWidth="md" formType={Dtos.BankGuaranteeRequest} data-sentry-element="FormContainer" data-sentry-component="BankGuaranteeRequest" data-sentry-source-file="BankGuarenteeRequest.tsx">
            {/* FieldProvider is placed here so form level errors will appear on the form. */}
            <FieldProvider name="id" data-sentry-element="FieldProvider" data-sentry-source-file="BankGuarenteeRequest.tsx" />
            <Paper className={classes.paper} data-sentry-element="Paper" data-sentry-source-file="BankGuarenteeRequest.tsx">
                <Field name="jobNumber" component={Text} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="ourCompany" component={FuzzySelect} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="nameBankGuaranteesToBeInFavourOf" component={TextArea} rows={2} rowsMax={2} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="address" component={TextArea} rows={2} rowsMax={2} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="projectId" component={FuzzySelect} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="projectDetails" component={TextArea} rows={2} rowsMax={2} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="contractSum" component={Numeric} numberFormat={MONEY_FORMAT} margin={fieldMargin} InputProps={DOLLAR_PREFIX} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="percentOfBankGuarantees" component={Numeric} numberFormat={PERCENTAGE_FORMAT} margin={fieldMargin} InputProps={PERCENT_SUFFIX} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="numberOfGuarantees" component={Numeric} numberFormat={INTEGER_FORMAT} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="amountOfEachGuarantee" component={Numeric} numberFormat={MONEY_FORMAT} margin={fieldMargin} InputProps={DOLLAR_PREFIX} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <TotalAmountUpdater data-sentry-element="TotalAmountUpdater" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="totalAmountOfBankGuarantees" component={Numeric} numberFormat={MONEY_FORMAT} margin={fieldMargin} InputProps={DOLLAR_PREFIX} disabled data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="expectedReturnDate" component={DatePicker} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="expiryDateRequired" component={DatePicker} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Field name="notes" component={TextArea} margin={fieldMargin} rows={2} rowsMax={5} data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Attachment data-sentry-element="Attachment" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                <Grid container spacing={2} data-sentry-element="Grid" data-sentry-source-file="BankGuarenteeRequest.tsx">
                    <Grid item xs={12} md={8} data-sentry-element="Grid" data-sentry-source-file="BankGuarenteeRequest.tsx">
                        <Field name="enteredBy" component={Text} margin={gridFieldMargin} disabled data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                    </Grid>
                    <Grid item xs={12} md={4} data-sentry-element="Grid" data-sentry-source-file="BankGuarenteeRequest.tsx">
                        <Field name="enteredDate" component={DatePicker} margin={gridFieldMargin} disabled data-sentry-element="Field" data-sentry-source-file="BankGuarenteeRequest.tsx" />
                    </Grid>
                </Grid>
            </Paper>
        </FormContainer>;
};
export default BankGuaranteeRequest;